import CryptoJS from "crypto-js";
import axios from "axios";

// PhonePe Configuration
const PHONEPE_CONFIG = {
  environment: "PRODUCTION",
  merchantId: "M220EPK2S6J3T",
  saltKey: "c7339150-2515-449b-9ce5-d594445bf93c",
  saltIndex: "1",
  callbackUrl: "https://webhook.site/e6edc7d8-8e5d-4517-a9ae-3796863ddbae",
  apiEndPoint: "/pg/v1/pay",
  statusEndPoint: "/pg/v1/status",
  productionUrl: "https://api.phonepe.com/apis/hermes",
};

// Generate random transaction ID
export const generateTransactionId = () => {
  const randomNumber = Math.floor(Math.random() * 900000) + 100000;
  return randomNumber.toString();
};

// Generate checksum for PhonePe
export const generateChecksum = (base64Body, endpoint) => {
  const string = base64Body + endpoint + PHONEPE_CONFIG.saltKey;
  const sha256Hash = CryptoJS.SHA256(string).toString();
  return `${sha256Hash}###${PHONEPE_CONFIG.saltIndex}`;
};

// Create payment request
export const createPaymentRequest = (amount, phoneNo, userId, merchantTransactionId) => {
  const requestData = {
    merchantId: PHONEPE_CONFIG.merchantId,
    merchantTransactionId: merchantTransactionId,
    merchantUserId: userId,
    amount: amount * 100, // Convert to paise
    mobileNumber: phoneNo.toString(),
    redirectUrl: `${window.location.origin}/payment-redirect`,
    redirectMode: "REDIRECT",
    callbackUrl: PHONEPE_CONFIG.callbackUrl,
    paymentInstrument: {
      type: "PAY_PAGE",
    },
  };

  return requestData;
};

// Initiate PhonePe transaction
export const initiatePhonePeTransaction = async (amount, phoneNo, userId) => {
  try {
    const merchantTransactionId = generateTransactionId();
    const requestData = createPaymentRequest(amount, phoneNo, userId, merchantTransactionId);

    // Convert request to base64
    const base64Body = btoa(JSON.stringify(requestData));

    // Generate checksum
    const checksum = generateChecksum(base64Body, PHONEPE_CONFIG.apiEndPoint);

    // Make API call to PhonePe
    const response = await axios.post(
      `${PHONEPE_CONFIG.productionUrl}${PHONEPE_CONFIG.apiEndPoint}`,
      {
        request: base64Body,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "X-VERIFY": checksum,
        },
      }
    );

    if (response.data.success) {
      return {
        success: true,
        merchantTransactionId,
        redirectUrl: response.data.data.instrumentResponse.redirectInfo.url,
        checksum,
      };
    } else {
      return {
        success: false,
        error: response.data.message || "Payment initiation failed",
      };
    }
  } catch (error) {
    console.error("PhonePe transaction error:", error);
    return {
      success: false,
      error: error.response?.data?.message || error.message || "Payment failed",
    };
  }
};

// Check payment status
export const checkPaymentStatus = async (merchantTransactionId) => {
  try {
    const endpoint = `${PHONEPE_CONFIG.statusEndPoint}/${PHONEPE_CONFIG.merchantId}/${merchantTransactionId}`;
    const concatenatedString = `${endpoint}${PHONEPE_CONFIG.saltKey}`;
    const sha256Hash = CryptoJS.SHA256(concatenatedString).toString();
    const xVerify = `${sha256Hash}###${PHONEPE_CONFIG.saltIndex}`;

    const response = await axios.get(
      `${PHONEPE_CONFIG.productionUrl}${endpoint}`,
      {
        headers: {
          "Content-Type": "application/json",
          "X-MERCHANT-ID": PHONEPE_CONFIG.merchantId,
          "X-VERIFY": xVerify,
        },
      }
    );

    if (response.data.code === "PAYMENT_SUCCESS" && response.data.data.responseCode === "SUCCESS") {
      return {
        success: true,
        transactionId: merchantTransactionId,
        xVerify,
        data: response.data.data,
      };
    } else {
      return {
        success: false,
        error: response.data.message || "Payment verification failed",
      };
    }
  } catch (error) {
    console.error("Payment status check error:", error);
    return {
      success: false,
      error: error.response?.data?.message || error.message || "Status check failed",
    };
  }
};
